export default __webpack_public_path__ + "static/9_20-cf5e7942334084ed1691e0a80d4768e1.png";